import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  updateVisibility,
  getSnapShots,
  getSnapShot,
} from "../../../../../action/masters/snapShotActionCreator";
import { cloneDeep, baseURL } from "../../../../../constants/commonConstants";
import { getAlertData } from "../../../../../helper/sweet-alert";
import {
  ISnapShotIndex,
  ISnapShotData,
} from "../../../../../models/master/snapShot";
import { setSnapShots } from "../../../../../store/slices/master/snapShotSlice";
import SnapShotEdit from "./snapShotEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";

const SnapshotsIndex = (props: ISnapShotIndex) => {
  const {
    updateVisibility,
    getSnapShots,
    snapShots,
    getSnapShot,
    snapShot,
    configUserRole,
  } = props;
  const [showEdit, setShowEdit] = useState(false);
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(true);

  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);
  const dispatch = useDispatch();

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    let index = filteredItems.findIndex((x) => x.id == id);
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;
    updateVisibility(selectedItem, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      getAllSnapShots(configUserRole);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getSnapShot(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const getAllSnapShots = async (configUserRole: number) => {
    setIsLoading(true);
    try {
      await getSnapShots(configUserRole);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getAllSnapShots(configUserRole);
    return () => {
      dispatch(setSnapShots([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    snapShots && setfilteredItems(cloneDeep(snapShots));
  }, [snapShots]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Snapshot</h2>
        </div>
        <ul id="widget-sortable" className="sortable-card mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : snapShots && snapShots.length > 0 ? (
            snapShots.map((snapShot: ISnapShotData) => {
              return (
                <li className="setting-default">
                  <div className="btm">
                    {snapShot.image && (
                      <div className="img">
                        <img
                          src={snapShot.image ? baseURL + snapShot.image : ""}
                          alt=""
                        />
                      </div>
                    )}

                    <h3>{snapShot.name}</h3>
                    <div className="ms-auto d-flex justify-content-end align-items-center gap-3">
                      <div className="btn-toggle">
                        <input
                          type="checkbox"
                          checked={snapShot.displayOrNot}
                          id={snapShot.id + "snapshot"}
                          onChange={() => {
                            if (snapShot.displayOrNot && !snapShot.image) {
                              setAlertType("error");
                              setAlertTitle("Please upload a snapshot image to disable this block");
                              setShowConfirm(true);
                              setShowAlert(true);
                              return;
                            }
                            ChangeVisibleOrNot(
                              snapShot.id ?? 0,
                              !snapShot.displayOrNot
                            );
                          }}
                          className="switch-toggle"
                        />

                        <label htmlFor={snapShot.id + "snapshot"}></label>
                      </div>
                      <button
                        className="btn-edit"
                        data-bs-toggle="modal"
                        data-bs-target="#fillerimage"
                        onClick={() => editItem(snapShot.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <SweetAlert
        show={showAlert}
        type={alertType}
        title={alertTitle}
        onConfirm={() => {
          setShowAlert(false);
          setShowConfirm(true);
        }}
        showCancel={false}
        confirmBtnText="OK"
        showCloseButton={true}
        closeBtnStyle={{ color: "#948256" }}
        showConfirm={showConfirm}
      />
      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <SnapShotEdit
            setShowEdit={handleEditClose}
            getAllSnapShots={() => getAllSnapShots(configUserRole)}
            snapShot={snapShot}
          />
        </ReactModal>
      )}
    </>
  );
};

const mapDispatchToProps = {
  updateVisibility: (data: any, callBack: Function) =>
    updateVisibility(data, callBack),
  getSnapShots: (configUserRole: number) => getSnapShots(configUserRole),
  getSnapShot: (id: number) => getSnapShot(id),
};

function mapStateToProps(state: any) {
  return {
    snapShots: state.snapShot.snapShots,
    snapShot: state.snapShot.snapShot,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SnapshotsIndex);
